import { Alert, AlertDescription, AlertTitle } from "@qw/ui";

import { EmailLink } from "../components/email-link";
import { useConversation } from "../providers/use-conversation";

export const ConversationReadOnlyAlert = () => {
  const { inboxConversation } = useConversation();
  const conversationInbox = inboxConversation?.inbox;

  if (!conversationInbox) {
    return null;
  }

  return (
    <div className="p-3 pb-1.5">
      <Alert variant="default" icon="visibility_lock">
        <AlertTitle>You are viewing a read-only version of this conversation.</AlertTitle>
        <AlertDescription className="items-start">
          <p>
            You do not have permission to perform actions on this conversation. To reply to this conversation, first
            request the owner, <EmailLink to={conversationInbox.email} />, forward the conversation to you.
          </p>
        </AlertDescription>
      </Alert>
    </div>
  );
};
